(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aef-for-you"] && !Shopify.designMode) return;
  try {
    
  class AefForYou extends HTMLElement {
    connectedCallback() {
      // If Shopify already rendered recommendations into this instance
      // (i.e. this IS the fetched section render), just show them.
      if (this.querySelector('.aef-prow__reco').children.length) {
        this.removeAttribute('hidden');
        return;
      }
      var seed = this._lastViewedId();
      if (!seed) return; // no browse history → stay hidden

      var url = this.dataset.url
        + '?section_id=' + encodeURIComponent(this.dataset.sectionId)
        + '&product_id=' + encodeURIComponent(seed)
        + '&intent=related'
        // Luôn xin ĐỦ 10 (trần của /recommendations), không xin đúng số ô.
        // Liquid lọc hàng hết rồi mới cắt còn `section.settings.limit`; xin
        // đúng 8 mà 3 món hết hàng thì dãy teo xuống 5 ô.
        + '&limit=10';

      var self = this;
      var run = function () {
        fetch(url, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (text) {
            if (!text) return;
            var holder = document.createElement('div');
            holder.innerHTML = text;
            var fetched = holder.querySelector('.aef-prow__reco');
            if (fetched && fetched.children.length) {
              self.querySelector('.aef-prow__reco').innerHTML = fetched.innerHTML;
              self.removeAttribute('hidden');
              // Thẻ vừa tiêm vào DOM SAU khi bộ dịch đã chạy, nên phải báo lại.
              // Bản cũ gọi window.aefApplyI18n() rồi bắn 'aef:i18n:apply' —
              // KHÔNG có cái nào tồn tại: hàm đó không được định nghĩa ở bất kỳ
              // file nào, và không file nào nghe sự kiện đó. Kết quả là hàng "For
              // You" vĩnh viễn tiếng Anh khi khách bấm VI.
              // Hợp đồng thật của theme là 'aef:cards-injected'
              // (ae-delivery-widget.js:973 → applyTranslations). Nó còn được
              // card-stepper.js:436 nghe để dựng lại số lượng theo giỏ, nên dòng
              // này đồng thời sửa luôn chuyện nút +/− trên thẻ mới không khớp giỏ.
              try {
                document.dispatchEvent(new CustomEvent('aef:cards-injected', { detail: { sectionId: 'aef-for-you' } }));
              } catch (e) {}
            }
          })
          .catch(function () {});
      };

      // Do NOT gate on IntersectionObserver: this element is [hidden]
      // (display:none) until it has content, and a display:none element never
      // reports as intersecting — that would deadlock. The seed is known
      // synchronously, so just fetch at idle time and reveal on success.
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 1500 });
      } else {
        setTimeout(run, 300);
      }
    }

    _lastViewedId() {
      try {
        if (window.aefRV && typeof window.aefRV.history === 'function') {
          var h = window.aefRV.history();
          if (h && h.length && h[0].i) return h[0].i;
        }
        var raw = window.localStorage.getItem('aef_recently_viewed');
        var arr = raw ? JSON.parse(raw) : [];
        for (var i = 0; i < arr.length; i++) { if (arr[i] && arr[i].i) return arr[i].i; }
      } catch (e) {}
      return 0;
    }
  }
  customElements.define('aef-for-you', AefForYou);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  /* 15/9/2026 — ĐÃ GỠ class StickyHeader + customElements.define('sticky-header', …).
     Nó gắn window.addEventListener('scroll') trên MỌI trang, rồi mỗi sự kiện cuộn lại xếp
     thêm một requestAnimationFrame và ghi lớp lên phần tử .section-header — trong khi CẢ BA
     lớp nó ghi đều không còn ai đọc:
       · 'scrolled-past-header'          không một luật CSS nào trong kho đọc tới;
       · 'shopify-section-header-sticky' bị layout/theme.liquid vô hiệu bằng
                                         position: static !important + top: auto !important;
       · 'shopify-section-header-hidden' cũng ở đó, transform: none !important (luật
                                         translateY trong base.css đã bị chú thích từ lâu).
     Việc dính header vào đầu trang nay do .aef-sticky-wrap { position: sticky } trong
     layout/theme.liquid lo — một BẢO ĐẢM bằng CSS, không phải một lời gọi JS — nên gỡ khối
     này không đổi gì khách thấy, chỉ bớt việc mỗi khung hình khi cuộn.
     Markup <sticky-header> GIỮ NGUYÊN, cố ý: assets/global.js và assets/media-gallery.js
     còn querySelector('sticky-header') rồi dispatchEvent('preventHeaderReveal') — phát một
     sự kiện không ai nghe là vô hại, còn đổi thẻ sang <div> thì đổi display mặc định
     (inline → block) của thẻ bọc header, một rủi ro không ai cần.
     Người gác: scripts/test-sticky-header-khong-con-nghe-cuon.js */

  /* Keep cart drawer open when clicking inside it (delete buttons, qty, etc).
     Bootstrap dropdown closes on any document click — stopPropagation on the
     cart-icon-bubble container prevents the click reaching the document
     handler, while still letting webi-cart-remove-button's own handler fire. */
  document.addEventListener('DOMContentLoaded', function () {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    bubble.addEventListener('click', function (e) {
      if (e.target.closest('.dropdown-menu')) {
        e.stopPropagation();
      }
    });
  });

  /* BUG-R fix 2026-05-17 — Walmart/Weee-style hover-to-open menus.
     Cuisine + Category <details> dropdowns and the desktop language switcher
     auto-open on mouseenter and auto-close 200 ms after mouseleave (the grace
     timer prevents flicker when the cursor crosses from the trigger into the
     mega panel). Gated on matchMedia(hover: hover) and viewport ≥ 769 px so
     mobile keeps its native click-to-toggle behavior. Click still works on
     desktop too (browser handles <details> summary click + existing lang
     button handler) — hover is additive. */
  document.addEventListener('DOMContentLoaded', function () {
    var hoverMQ = window.matchMedia && window.matchMedia('(hover: hover) and (min-width: 769px)');
    if (!hoverMQ || !hoverMQ.matches) return;

    var HOVER_GRACE_MS = 200;

    /* 🔴 14/9/2026, vòng 48 (header-nav-2) — cờ `_aefOpenedByHover`.
       Trước cú vá này, trạng thái `open` của CÙNG một <details> có HAI người
       ghi mà không ai biết ai: (a) bộ hover ngay dưới đây, (b) hành vi MẶC ĐỊNH
       của trình duyệt khi bấm <summary>. Chuột vào vùng nút ⇒ mouseenter bắn
       TRƯỚC ⇒ đã `open`; khách bấm vào chữ "Shop by Category" (trông y như một
       nút, mà <summary> không có href nên bấm chẳng dẫn đi đâu) ⇒ người thứ hai
       lật ngược ⇒ bảng 12 ngành hàng BIẾN MẤT. Con trỏ vẫn nằm trong <details>
       nên KHÔNG có mouseleave → không có mouseenter mới → bảng nằm im cho tới
       khi khách bấm LẦN HAI. Đo trên LIVE (1440×900, hover:hover, 2/2 dropdown
       dính): hover → open=true · click → open=false · +900ms vẫn false.
       ae-delivery-widget.css:823 `.aef-menu-dropdown:not([open]) .aef-mega
       { display:none }` là luật DUY NHẤT hiện bảng, không có `:hover` đỡ.

       Vá bằng cờ MỘT LƯỢT chứ KHÔNG preventDefault vô điều kiện: <summary> mở
       bằng phím Enter cũng đi qua sự kiện `click`, chặn trắng là giết đường bàn
       phím (hỏng câm, mắt không thấy). Ba chốt an toàn:
         · cờ chỉ bật khi lúc mouseenter details CHƯA mở — khách mở bằng Tab+
           Enter rồi mới rê chuột tới thì cú bấm để ĐÓNG vẫn đi lọt;
         · chỉ nuốt khi details ĐANG mở thật (hasAttribute('open'));
         · hạ cờ trong CHÍNH đồng hồ 200ms (không hạ lúc mouseleave), để cú rê
           ra-vào trong 200ms — menu chưa hề đóng — vẫn được bảo vệ. */
    function bindDropdownHover(details) {
      if (details._aefHoverBound) return;
      details._aefHoverBound = true;
      var timer = null;
      details.addEventListener('mouseenter', function () {
        if (timer) { clearTimeout(timer); timer = null; }
        if (!details.hasAttribute('open')) details._aefOpenedByHover = true;
        details.setAttribute('open', '');
      });
      details.addEventListener('mouseleave', function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          details.removeAttribute('open');
          details._aefOpenedByHover = false;
          timer = null;
        }, HOVER_GRACE_MS);
      });
      var summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function (e) {
          if (details.hasAttribute('open') && details._aefOpenedByHover) {
            e.preventDefault();
            details._aefOpenedByHover = false;
          }
        });
      }
    }

    document.querySelectorAll('.aef-menu-dropdown').forEach(bindDropdownHover);

    /* Language switcher — toggles `.aef-lang-menu hidden` attribute. The
       existing click handler in ae-delivery-widget.js (`wireLangSwitchers`)
       handles click + outside-click + ESC; we only ADD hover behavior. */
    document.querySelectorAll('.aef-lang-desktop').forEach(function (root) {
      if (root._aefLangHoverBound) return;
      root._aefLangHoverBound = true;
      var trigger = root.querySelector('[data-aef-lang-trigger]');
      var menu = root.querySelector('[data-aef-lang-menu]');
      if (!trigger || !menu) return;
      var timer = null;
      root.addEventListener('mouseenter', function () {
        if (timer) { clearTimeout(timer); timer = null; }
        if (menu.hidden) root._aefOpenedByHover = true;
        menu.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      });
      root.addEventListener('mouseleave', function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          menu.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
          root._aefOpenedByHover = false;
          timer = null;
        }, HOVER_GRACE_MS);
      });
      /* 🔴 14/9/2026, vòng 48 (header-nav-2) — nút "🔤 EN ▾" hỏng NẶNG HƠN hai
         nút nav: nó không có đích nào khác, bấm vào nó LÀ đường chính. Đo trên
         LIVE: hover → hidden=false · click → hidden=true · +900ms vẫn true.
         Kẻ ghi thứ hai là `wireLangSwitchers` (ae-delivery-widget.js:1460
         `var open = menu.hidden === false; menu.hidden = open;`) — nó đọc đúng
         cái trạng thái bộ hover vừa ghi rồi lật ngược.
         File đó KHÔNG thuộc quyền vòng này, nên chặn từ phía mình: nghe ở pha
         CAPTURE trên phần tử CHA (`root`). Gắn thêm listener lên CHÍNH `trigger`
         là vô ích — ở AT_TARGET cờ capture bị bỏ qua, listener chạy theo thứ tự
         đăng ký, mà widget đăng ký từ lúc tải trang nên luôn chạy trước. Capture
         trên cha chạy TRƯỚC khi sự kiện tới trigger, và `stopPropagation()` ở đó
         chặn được cả listener nằm trên chính target.
         Hẹp đúng một lượt: chỉ khi bấm trúng `[data-aef-lang-trigger]` (đừng
         đụng hai nút English / Tiếng Việt trong menu — nuốt chúng là giết
         `setLang`), chỉ khi menu ĐANG mở (Escape đóng xong thì click phải mở
         lại được), và chỉ khi chính cú rê vừa mở nó (bàn phím vẫn đóng được). */
      root.addEventListener('click', function (e) {
        if (!e.target || !e.target.closest) return;
        if (!e.target.closest('[data-aef-lang-trigger]')) return;
        if (menu.hidden === false && root._aefOpenedByHover) {
          e.stopPropagation();
          root._aefOpenedByHover = false;
        }
      }, true);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              /* 🔴 18/8/2026 — BÁO LẠI SAU KHI TIÊM THẺ. Thiếu dòng này là hai lỗi:
                 · CHỮ: bộ dịch chạy ở DOMContentLoaded (ae-delivery-widget.js:1566
                   nghe 'aef:cards-injected'). Bốn thẻ này vào DOM SAU đó ⇒ giữa một
                   trang tiếng Việt, khối cuối trang hiện 4 nút "Add to cart" tiếng
                   Anh và giữ nguyên suốt lượt xem.
                 · SỐ LƯỢNG: card-stepper.js cũng nghe sự kiện này để dựng lại nút
                   +/− theo giỏ đang có. Thẻ mới không được báo thì nút của chúng
                   không biết trong giỏ đã có mấy món — đây là lỗi TIỀN.
                 aef-for-you.liquid đã làm đúng từ đầu; đây là chép lại cùng hợp đồng
                 cho dãy còn thiếu. */
              try {
                document.dispatchEvent(new CustomEvent('aef:cards-injected', { detail: { sectionId: 'product-recommendations' } }));
              } catch (e) {}
            } else {
              /* 🔴 8/9/2026 (vòng 45) — Shopify không trả gợi ý nào. Khung giữ chỗ phải
                 ĐI, nếu không khách đứng nhìn 4 ô xám nhấp nháy tới hết lượt xem. */
              this.innerHTML = '';
            }
          })
          .catch(e => {
            /* Lấy về hỏng cũng phải dọn khung — cùng lý do với nhánh else ở trên. */
            this.innerHTML = '';
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbquickview"]) return;
  try {
    
        class ProductModal extends ModalDialog {
          constructor() {
            super();
          }

          hide() {
            super.hide();
          }

          show(opener) {
            super.show(opener);
            this.showActiveMedia();
          }

          showActiveMedia() {
            this.querySelectorAll(
              `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
            ).forEach((element) => {
              element.classList.remove('active');
            });
            const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
            const activeMediaTemplate = activeMedia.querySelector('template');
            const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
            activeMedia.classList.add('active');
            activeMedia.scrollIntoView();

            const container = this.querySelector('[role="document"]');
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

            if (
              activeMedia.nodeName == 'DEFERRED-MEDIA' &&
              activeMediaContent &&
              activeMediaContent.querySelector('.js-youtube')
            )
              activeMedia.loadContent();
          }
        }

        customElements.define('product-modal', ProductModal);
      
  } catch(e) { console.error(e); }
})();
})();
